/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckEmailResponse
 */
export interface CheckEmailResponse {
    /**
     * Whether the requested email address is a valid member of the institution.
     * @type {boolean}
     * @memberof CheckEmailResponse
     */
    validMember?: boolean;
    /**
     * Whether the requested email address already has an existing account.
     * @type {boolean}
     * @memberof CheckEmailResponse
     */
    existingAccount?: boolean;
}

/**
 * Check if a given object implements the CheckEmailResponse interface.
 */
export function instanceOfCheckEmailResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckEmailResponseFromJSON(json: any): CheckEmailResponse {
    return CheckEmailResponseFromJSONTyped(json, false);
}

export function CheckEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEmailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validMember': !exists(json, 'validMember') ? undefined : json['validMember'],
        'existingAccount': !exists(json, 'existingAccount') ? undefined : json['existingAccount'],
    };
}

export function CheckEmailResponseToJSON(value?: CheckEmailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'validMember': value.validMember,
        'existingAccount': value.existingAccount,
    };
}

